<template>
  <div class="row">
    <div class="col-12 mb-2">
      <b-card :header="this.$route.meta.title" header-tag="h4" class="bg-default-card">
        <div class="row">
          <div class="col-6 offset-6" v-if="payroll_export_rows !== null && payroll_export_rows.length > 0">
            <button class="btn orcaBtn w-100 sm_btn" @click.prevent="export_payroll_workers" :disabled="exporting">
              <span v-if="!exporting"><i class="fa fa-download"></i>&nbsp; Payroll Worker Export (CSV)</span>
              <span v-if="exporting"><i class="fas fa-spinner fa-pulse"></i>&nbsp; Exporting ...</span>
            </button>
          </div>
          <div class="col-12 mt-4">
            <datatable :type="''" :recordType="''" :rowData="payroll_export_rows" :loadingMessage="loadingMessage"
                       :noRowsMessage="noRowsMessage" :columns="columns" :heightStyle="heightStyle"></datatable>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import datatable from "datatables/export_datatable";

export default {
  name: 'sage_payroll_workers_export',
  components: {
    datatable,
    'delete_row': {
      name: 'delete_row',
      template: '<div>' +
          '<button class="btn orcaBtn sm_btn danger" @click.prevent="remove(params.data.id)"><i class="fas fa-trash-alt"></i></button>' +
          '</div>',
      methods: {
        remove(id) {
          axios.delete(this.crmApiPath + 'finance/export/worker/payroll/destroy/' + id).then(() => {
            this.$nextTick(() => this.$parent.$parent.$parent.refreshSPEtable = 1);
            this.$bus.$emit('worker:sage:export');
          })
        },
      }
    }
  },
  data() {
    return {
      heightStyle: 'height: 400px !important',
      loadingMessage: 'Loading Workers...',
      noRowsMessage: 'No Workers Queued for Export',
      payroll_export_rows: null,
      isContractor: false,

      refreshSPEtable: 0,
      columns: [
        {headerName: '', minWidth: 60, field: 'id', cellRendererFramework: 'delete_row', filter: false, sort: false},
        {headerName: 'Employee Reference', field: 'employee_reference', minWidth: 110, suppressSizeToFit: true},
        {headerName: 'Works Reference', field: 'works_reference', minWidth: 110, suppressSizeToFit: true},
        {headerName: 'Title', field: 'title', minWidth: 80, suppressSizeToFit: true},
        {headerName: 'Initial', field: 'initial', minWidth: 80, suppressSizeToFit: true},
        {headerName: 'Forename', field: 'forename', minWidth: 135, suppressSizeToFit: true},
        {headerName: 'Surname', field: 'surname', minWidth: 135, suppressSizeToFit: true},
        {headerName: 'Address 1', field: 'address_1', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'Address 2', field: 'address_2', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'Address 3', field: 'address_3', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'Address 4', field: 'address_4', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'Address 5', field: 'address_5', minWidth: 160, suppressSizeToFit: true},
        {headerName: 'Post Code', field: 'postcode', minWidth: 130, suppressSizeToFit: true},
        {headerName: 'Email Address', field: 'e_mail_address', minWidth: 225, suppressSizeToFit: true},
        {headerName: 'Telephone Number', field: 'telephone_number', minWidth: 110, suppressSizeToFit: true},
        {headerName: 'Gender', field: 'gender', minWidth: 95, suppressSizeToFit: true},
        {headerName: 'Nationality', field: 'nationality', minWidth: 150, suppressSizeToFit: true},
        {headerName: 'Marital Status', field: 'marital_status', minWidth: 100, suppressSizeToFit: true},
        {headerName: 'Date of Birth', field: 'date_of_birth', minWidth: 90, suppressSizeToFit: true},
        {headerName: 'Work Start Date', field: 'work_start_date', minWidth: 115, suppressSizeToFit: true},
        {headerName: 'Work End Date', field: 'work_end_date', minWidth: 115, suppressSizeToFit: true},
        {headerName: 'NI Number', field: 'ni_number', minWidth: 115, suppressSizeToFit: true},
        {headerName: 'NI Category', field: 'ni_category', minWidth: 115, suppressSizeToFit: true},
        {headerName: 'Tax Code', field: 'tax_code', minWidth: 100, suppressSizeToFit: true},
        {headerName: 'Payment Method', field: 'payment_method', minWidth: 100, suppressSizeToFit: true},
        {headerName: 'Payment Frequency', field: 'payment_frequency', minWidth: 110, suppressSizeToFit: true},
        {headerName: 'Sort Code', field: 'sort_code', minWidth: 105, suppressSizeToFit: true},
        {headerName: 'Bank Account Number', field: 'bank_account_number', minWidth: 130, suppressSizeToFit: true},
        {headerName: 'Bank Account Name', field: 'bank_account_name', minWidth: 130, suppressSizeToFit: true},
        {headerName: 'Building Soc Number', field: 'building_soc_number', minWidth: 130, suppressSizeToFit: true},
        {headerName: 'BACS Reference', field: 'bacs_reference', minWidth: 130, suppressSizeToFit: true},
        {headerName: 'Bank Name', field: 'bank_name', minWidth: 110, suppressSizeToFit: true},
        {headerName: 'Mobile Number', field: 'mobile_number', minWidth: 110, suppressSizeToFit: true},
        {headerName: 'Job Title', field: 'job_title', minWidth: 150, suppressSizeToFit: true},
        {headerName: 'Analysis 1', field: 'analysis_1', minWidth: 210, suppressSizeToFit: true},
        {headerName: 'Analysis 3', field: 'analysis_3', minWidth: 120, suppressSizeToFit: true},
        {headerName: 'Right To Work Confirm Status', field: 'right_to_work_confirm_status', minWidth: 140, suppressSizeToFit: true},
      ],
      exporting: false
    }
  },
  mounted() {
    this.popTable();
  },
  methods: {
    popTable() {
      let type = this.$route.name;
      axios.get(this.crmApiPath + 'finance/export/worker/payroll?type=' + type).then(res => {
        this.payroll_export_rows = []
        for (let i = 0; i < res.data.length; i++) {
          // Declare Variables
          let employee_reference = '', works_reference = '', title = '', initial = '', forename = '', surname = '',
              address_1 = '', address_2 = '', address_3 = '', address_4 = '', address_5 = '', postcode = '',
              email = '', telephone = '', gender = '', nationality = '', date_of_birth = '', ni_number = '',
              sort_code = '', account_number = '', account_holder = '', building_society_ref = '', bacs_reference = '', bank_name = '',
              mobile = '', job_title = '', analysis_1 = '', analysis_3 = '';

          // if limited company and has company_internal_finance_ref use this number -> else use worker internal_finance_ref
          if (res.data[i].worker.rel_company_info.employment_type_id === 32 && res.data[i].worker.rel_company_info.company_internal_finance_ref !== null) {
            employee_reference = res.data[i].worker.rel_company_info.company_internal_finance_ref;
            works_reference = res.data[i].worker.rel_company_info.company_internal_finance_ref;
          }
          else {
            employee_reference = res.data[i].worker.internal_finance_ref;
            works_reference = res.data[i].worker.internal_finance_ref;
          }
          // Worker Title
          title = res.data[i].worker.person.title_id !== null ? res.data[i].worker.person.title.value : '';
          // Worker Initial
          if (res.data[i].worker.person.first_name !== null && res.data[i].worker.person.first_name !== '') {
            initial = res.data[i].worker.person.first_name.substring(0, 1).toUpperCase()
          }
          // Worker Forename
          if (res.data[i].worker.person.first_name !== null && res.data[i].worker.person.first_name !== '') {
            forename = res.data[i].worker.person.first_name
          }
          // Worker Surname
          if (res.data[i].worker.person.surname !== null && res.data[i].worker.person.surname !== '') {
            surname = res.data[i].worker.person.surname
          }
          // address get (check for company address first [and if different from personal address])
          if (res.data[i].worker.rel_addresses.find(a => a.address_type_id === 106) !== undefined && !res.data[i].worker.rel_company_info.company_address_same_as_personal) {
            let temp = res.data[i].worker.rel_addresses.find(a => a.address_type_id === 106);
            if (temp.building !== null && temp.building !== '') {
              if (temp.street !== null && temp.street !== '') {
                address_1 = temp.building + ', ' + temp.street
              }
              else {
                address_1 = temp.building
              }
            }
            else {
              if (temp.street !== null && temp.street !== '') {
                address_1 = temp.street
              } else {
                address_1 = ''
              }
            }
            address_2 = temp.city_town !== null && temp.city !== '' ? temp.city_town : '';
            address_3 = temp.locality !== null && temp.locality !== '' ? temp.locality : '';
            address_4 = ''
            address_5 = temp.county !== null && temp.county !== '' ? temp.county : '';
            postcode = temp.postcode !== null && temp.postcode !== '' ? temp.postcode : '';
          }
          // else use personal address
          else if (res.data[i].worker.rel_addresses.find(a => a.address_type_id === 47) !== undefined) {
            let temp = res.data[i].worker.rel_addresses.find(a => a.address_type_id === 47);
            if (temp.building !== null && temp.building !== '') {
              if (temp.street !== null && temp.street !== '') {
                address_1 = temp.building + ', ' + temp.street
              }
              else {
                address_1 = temp.building
              }
            }
            else {
              if (temp.street !== null && temp.street !== '') {
                address_1 = temp.street
              } else {
                address_1 = ''
              }
            }
            address_2 = temp.city_town !== null && temp.city !== '' ? temp.city_town : '';
            address_3 = temp.locality !== null && temp.locality !== '' ? temp.locality : '';
            address_4 = ''
            address_5 = temp.county !== null && temp.county !== '' ? temp.county : '';
            postcode = temp.postcode !== null && temp.postcode !== '' ? temp.postcode : '';
          }
          // Email get
          email = res.data[i].worker.rel_emails.find(e => e.email_type_id === 67) !== undefined ? res.data[i].worker.rel_emails.find(e => e.email_type_id === 67).email_address : '';
          // Telephone Phone get
          telephone = res.data[i].worker.rel_phones.find(e => e.phone_type_id === 58) !== undefined ? res.data[i].worker.rel_phones.find(e => e.phone_type_id === 58).phone_number : '';
          // Gender
          if (res.data[i].worker.person.title_id !== null) {
            switch (res.data[i].worker.person.title.value) {
              case 'Mrs':
                gender = "F"
                break
              case 'Ms':
                gender = "F"
                break
              case 'Miss':
                gender = "F"
                break
              default:
                gender = "M"
            }
          }
          else {
            gender = 'M'
          }
          // Nationality
          nationality = res.data[i].worker.person.nationality_id !== null ? res.data[i].worker.person.nationality.nationality : '';
          // Date of Birth
          date_of_birth = res.data[i].worker.person.dob !== null ? this.$options.filters.formatDate(res.data[i].worker.person.dob) : '';
          // NI Number
          if (res.data[i].worker.rel_profile.ni_number !== null && res.data[i].worker.rel_profile.ni_number !== '') {
            ni_number = res.data[i].worker.rel_profile.ni_number
          }
          // if company bank details exist use these (they may be the same as personal) else use personal bank details
          if (res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40) !== undefined && !res.data[i].worker.rel_company_info.company_bank_same_as_personal) {
            if (res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).sort_code !== null) {
              sort_code = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).sort_code.substring(0, 2) + '-' +
                  res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).sort_code.substring(2, 4) + '-' +
                  res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).sort_code.substring(4, 6)
            }
            account_number = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).account_number !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).account_number : '';
            account_holder = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).accounts_holder !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).accounts_holder : '';
            building_society_ref = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).building_society_ref !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).building_society_ref : '';
            bank_name = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).bank_name !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 40).bank_name : '';
          }
          else if (res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39) !== undefined) {
            if (res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).sort_code !== null) {
              sort_code = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).sort_code.substring(0, 2) + '-' +
                  res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).sort_code.substring(2, 4) + '-' +
                  res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).sort_code.substring(4, 6)
            }
            account_number = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).account_number !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).account_number : '';
            account_holder = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).accounts_holder !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).accounts_holder : '';
            building_society_ref = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).building_society_ref !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).building_society_ref : '';
            bank_name = res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).bank_name !== null ?
                res.data[i].worker.rel_banks.find(e => e.bank_type_id === 39).bank_name : '';
          }
          // BACS Reference
          if (this.crmType === 'payroll') {
            bacs_reference = 'Genius Money'
          }
          if (this.crmType === 'recruitment') {
            bacs_reference = 'V3 Recruitment'
          }
          // Mobile Number
          mobile = res.data[i].worker.rel_phones.find(e => e.phone_type_id === 59) !== undefined
              ? res.data[i].worker.rel_phones.find(e => e.phone_type_id === 59).phone_number : '';
          // Job Title
          job_title = res.data[i].worker.rel_profile.job_title_id !== undefined && res.data[i].worker.rel_profile.job_title_id !== null ? res.data[i].worker.rel_profile.job_title.job_title : '';
          // Analysis 1
          analysis_1 = res.data[i].worker.rel_phones.find(e => e.phone_type_id === 59) !== undefined
              ? res.data[i].worker.rel_phones.find(e => e.phone_type_id === 59).phone_number + '@textmarketer.biz' : '';
          // Analysis 3 (if Limited company -> company_utr_number) ELSE personal_utr_number
          if (res.data[i].worker.rel_company_info.employment_type_id === 32) {
            if (res.data[i].worker.rel_company_info.company_utr_number !== null) {
              analysis_3 = res.data[i].worker.rel_company_info.company_utr_number
            }
            // if there is no company_utr_number but there is a personal_utr_number use this
            else if (res.data[i].worker.rel_profile.personal_utr_number !== null) {
              analysis_3 = res.data[i].worker.rel_profile.personal_utr_number
            }
            else {
              analysis_3 = ''
            }
          }
          else if (res.data[i].worker.rel_company_info.employment_type_id === 29 || res.data[i].worker.rel_company_info.employment_type_id === 30) {
            analysis_3 = res.data[i].worker.rel_profile.personal_utr_number !== null ? res.data[i].worker.rel_profile.personal_utr_number : '';
          }
          // PAYE
          else {
            analysis_3 = ''
          }

          this.payroll_export_rows.push({
            'id': res.data[i].id,
            'worker_id': res.data[i].worker.id,
            'employee_reference': employee_reference,
            'works_reference': works_reference,
            'title': title,
            'initial': initial,
            'forename': forename,
            'surname': surname,
            'address_1': address_1,
            'address_2': address_2,
            'address_3': address_3,
            'address_4': address_4,
            'address_5': address_5,
            'postcode': postcode,
            'e_mail_address': email,
            'telephone_number': telephone,
            'gender': gender,
            'nationality': nationality,
            'marital_status': 'Single', // Marital Status === default : single
            'date_of_birth': date_of_birth,
            'work_start_date': this.$moment.utc().isoWeekday(-6).format('DD/MM/YYYY'),
            'work_end_date': '', // Work End Date === default : ''
            'ni_number': ni_number,
            'ni_category': 'X', // NI Category === default : X
            'tax_code': 'NT', // Tax Code === default : NT
            'payment_method': 'BACS', // Payment Method === default : BACS
            'payment_frequency': 'Weekly', // Payment Frequency === default : Weekly
            'sort_code': sort_code,
            'bank_account_number': account_number,
            'bank_account_name': account_holder,
            'building_soc_number': building_society_ref,
            'bacs_reference': bacs_reference,
            'bank_name': bank_name,
            'mobile_number': mobile,
            'job_title': job_title,
            'analysis_1': analysis_1,
            'analysis_3': analysis_3,
            'right_to_work_confirm_status': 1 // Right to Work Confirm Status === : default 1 (true)
          });
        }
      });
    },
    export_payroll_workers() {
      this.exporting = true;
      axios.post(this.crmApiPath + 'finance/export/worker/payroll/export', this.payroll_export_rows, {
        responseType: 'arraybuffer'
      }).then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Payroll_workers_export_' + this.$moment.utc().format('DD-MM-YYYY-hh-mm') + '.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        axios.post(this.crmApiPath + 'finance/export/worker/payroll/exported?type=' + this.$route.name).then(() => {
          this.$bus.$emit('worker:sage:export');
          this.refreshSPEtable = 1;
          this.exporting = false;
        });
      })
    }
  },
  watch: {
    refreshSPEtable(val) {
      if (val === 1) {
        this.payroll_export_rows = null;
        this.popTable();
        this.refreshSPEtable = 0;
      }
    }
  },
  beforeDestroy() {
    this.payroll_export_rows = null;
    this.columns = [];
  }
}
</script>
